import { render, staticRenderFns } from "./PriceTierList.vue?vue&type=template&id=066bb351"
import script from "./PriceTierList.vue?vue&type=script&lang=js"
export * from "./PriceTierList.vue?vue&type=script&lang=js"
import style0 from "./PriceTierList.vue?vue&type=style&index=0&id=066bb351&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports